<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="detail-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="title"></div>
                    <div class="main-title"></div>
                    <div class="reward-view">
                        <vuescroll>
                        <div class="reward-list flex-start-start flex-wrap">
                            <div class="reward-pic" v-for="(item,index) in list" v-tips="item.giftId"
                            :key="index">
                                <game-item :id="item.giftId" :num="item.sendNum" :locked="true"></game-item>
                            </div>                           
                        </div>
                        </vuescroll>
                    </div>
                </div>
            </div>
            
            <div class="u-btn  apply-599" v-if="($store.state.userinfo.uflag & 2) != 2" @click="buy_599pass()"></div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
@include responseTo("desktop"){
    .detail-modal{
        transform: scale(0.7);
    }
}

.detail-modal{
    position: relative;
    padding: 0;
    top: 8%;
    background-color: transparent;
    border: none;

    .dialog-content{
        position: relative;
        width: 667px;
        height: 488px;
        padding-top: 40px;
        box-sizing: border-box;
        background-image: url(~@/assets/images/modal/pannel-pass.png);
    }

    .dialog-wrapper{
        padding-top: 40px;
    }


    &::before{
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        top: 5%;
        transform: translate(-50%,-50%);
        width: 780px;
        height: 633px;
        background-image: url(~@/assets/images/modal/layer-detail.png);
    }
}

.title{
    width: 385px;
    height: 20px;
    margin: 0 auto 40px;
    background-image: url(~@/assets/images/modal/title-pass.png);
}

.main-title{
    position: absolute;
    left: 50%;
    top: -60px;
    width: 485px;
    height: 115px;
    transform: translateX(-50%);
    background-image: url(~@/assets/images/modal/title-pass_detail.png);
}

.reward-view{
    height: 350px;

    .reward-list{
        padding: 0 50px;
    }

    .reward-pic{
        width: 64px;
        height: 64px;
        margin: 0 24px 38px;
    }
}

.u-btn.close{
    top: 125%;
    left: 50%;
    transform: translateX(-50%);
    right: auto;
    width: 44px;
    height: 44px;
    background-image: url(~@/assets/images/modal/btn-close_2.png);
}

.apply-599{
    position: relative;
    width: 328px;
    height: 80px;
    margin: 20px auto 0;
    background-image: url(~@/assets/images/btn-buy-599.png);
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            list : [
                {"giftId":"OX14","giftName":"鸡王封灵玉豪华体验包","sendNum":"1"},
                {"giftId":"AM80","giftName":"会员(90天)","sendNum":"1"},
                {"giftId":"Y819","giftName":"神奇鸡毛(90天)","sendNum":"60"},
                {"giftId":"1","giftName":"金鸡币","sendNum":"1400"},
                {"giftId":"OJ22","giftName":"鸡王宠物自选包","sendNum":"1"},
                {"giftId":"PM95","giftName":"春宴代币","sendNum":"1000"},
                {"giftId":"OL66","giftName":"竞技特效自选包2（7天）","sendNum":"1"},
                {"giftId":"PK04","giftName":"春节活动抽奖券","sendNum":"30"},
                {"giftId":"OL64","giftName":"鸡王武器自选包","sendNum":"1"},
                {"giftId":"OW78","giftName":"闪光灯","sendNum":"3000"},
                {"giftId":"PK48","giftName":"蒲元称号","sendNum":"1"},
                {"giftId":"KR48","giftName":"活跃自选礼包（7天）","sendNum":"12"},
                {"giftId":"F887","giftName":"封灵玉碎片(30天)","sendNum":"300"},
                {"giftId":"KQ92","giftName":"天鸡不可泄露(90天)","sendNum":"1"}
            ]
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条 
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        buy_599pass(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            this.destroyElement();
            this.$pass_comfirm();
        },                            
    },    
}
</script>